import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import MuiToggleButton from "@mui/material/ToggleButton";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { PaletteColors } from "@/theme/PaletteOverrides.ts";

import { AtomProps, StyleClasses } from "./utils/AtomTypes";

export type BaseToggleButtonProps = PropsWithChildren<{
  "data-action": string;
  value: string;
  color?: PaletteColors;
  toggled: boolean;
  onToggle: () => void;
  disabled?: boolean;
  title?: string;
  className?: string;
}>;

export type ToggleButtonProps = AtomProps<BaseToggleButtonProps, StyleClasses<"root" | "toggled">>;

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  toggled,
  onToggle,
  children,
  className,
  classes,
  disabled,
  ...props
}) => {
  const styles = useStyles(makeStyles);
  return (
    <MuiToggleButton
      size="small"
      className={cx(styles.container, className, classes?.root, {
        [classes?.toggled ?? "toggled"]: toggled,
      })}
      selected={toggled}
      onClick={disabled ? undefined : onToggle}
      disabled={disabled}
      {...props}
    >
      {children}
    </MuiToggleButton>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    padding: theme.spacing(1, 4),
  }),
});
